// Use libphonenumber-js for reliable calling code mapping
// This ensures ALL countries have correct calling codes
import { getCountryCallingCode, getCountries } from 'libphonenumber-js';

// Get phone code for a country ISO2 code
// Returns E.164 format calling code (e.g., "+93" for Afghanistan)
// Uses libphonenumber-js which has complete, accurate data for all countries
export const getPhoneCode = (iso2: string): string => {
  try {
    const callingCode = getCountryCallingCode(iso2.toUpperCase() as any);
    return `+${callingCode}`;
  } catch (error) {
    // Fallback only if ISO2 is completely invalid
    // This should rarely happen with proper country selection
    console.error(`Invalid country ISO2: ${iso2}`, error);
    return "+1"; // Safe default
  }
};

// Get all available countries from libphonenumber-js
export const getAvailableCountries = (): string[] => {
  return getCountries();
};

// Validate if a country ISO2 is valid
export const isValidCountryCode = (iso2: string): boolean => {
  try {
    getCountryCallingCode(iso2.toUpperCase() as any);
    return true;
  } catch {
    return false;
  }
};
